import type { ShortDaysOfWeek } from '@brighterly/lib-core-types/options/enums'
import type { TutorAvailability } from '@brighterly/lib-core-types/discipline/types'
import type { ScheduleStore, WeeklyScheduleSlot } from './interfaces'

import { useDisciplineStore } from '@stores/discipline'

const getAvailability = (state: ScheduleStore): TutorAvailability | null => {
  const disciplineStore = useDisciplineStore()

  return disciplineStore.isEla
    ? state.availabilityEla
    : disciplineStore.isMath
      ? state.availabilityMath
      : null
}

export const getters = {
  isModalSchedule: (state: ScheduleStore): boolean => state.modalSchedule,
  isModalRescheduleSuccess: (state: ScheduleStore): boolean => state.modalScheduleSuccess,
  isModalConfirmWeeklySchedule: (state: ScheduleStore): boolean => state.modalConfirmWeeklySchedule,
  isLoading: (state: ScheduleStore): boolean => state.loading,
  availableDates: (state: ScheduleStore): string[] => state.availableSlots.map(slot => slot.day),
  selectedDateSlots: (state: ScheduleStore): string[] => {
    if (!state.selectedDate) return []
    const found = state.availableSlots.find(slot => slot.day === state.selectedDate)
    return found ? found.slots : []
  },
  isFormValid: (state: ScheduleStore): boolean => {
    return !!(state.selectedDate && state.selectedTime)
  },
  getAvailability: (state: ScheduleStore): TutorAvailability | null => getAvailability(state),
  isAvailability: (state: ScheduleStore): boolean => !!getAvailability(state),
  getWeeklySchedule: (state: ScheduleStore): WeeklyScheduleSlot[] => {
    return state.weeklySchedule
  },
  getSelectedDays: (state: ScheduleStore): ShortDaysOfWeek[] => {
    return state.selectedDays
  },
  getShowErrors: (state: ScheduleStore): boolean => state.showErrors,
}
